module.exports = __webpack_public_path__ + "img/ivm.a7d7af42.gif";